"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTemplateRefined = void 0;
/**
 * Builds a notification trigger's template.
 */
const buildTemplateRefined = (template) => ({
    name: template.name,
    template: template.template,
    version: template.version,
    timestamp: template.timestamp,
    variables: template.variables,
});
exports.buildTemplateRefined = buildTemplateRefined;
//# sourceMappingURL=NotificationTemplateRefined.js.map